export const MAX_IMAGE_MB_SIZE = 1048576;
export const MAX_VIDEO_MB_SIZE = 1e8;
export const MAX_IMAGE_MB_ERROR_MESSAGE =
  "Las imágenes deben pesar menos de 1 MB";
export const MAX_VIDEO_MB_ERROR_MESSAGE =
  "Los videos deben pesar menos de 100 MB";
